import React from "react";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { MediaChooserBlock as BaseMediaChooserBlock } from "@thelabnyc/thelabui/src/components/MediaChooserBlock";
import { VideoChooserBlock } from "@thelabnyc/thelabui/src/components/VideoChooserBlock";

export const MediaChooserBlock = ({
    value,
    attrs,
}: React.ComponentProps<typeof BaseMediaChooserBlock>) =>
    value.map((block) => {
        switch (block.type) {
            case "image":
                return (
                    <ImageChooserBlock
                        key={block.id}
                        {...block}
                        attrs={attrs}
                    />
                );
            case "video":
                return (
                    <VideoChooserBlock
                        key={block.id}
                        {...block}
                        attrs={attrs}
                    />
                );
            default:
                return null;
        }
    });
